import { PromotionCreate } from './PromotionCreate'
import { PromotionList } from './PromotionList'
import { PromotionShow } from './PromotionShow'
import { PromotionEdit } from './PromotionEdit'

export { PromotionCreate, PromotionList, PromotionShow, PromotionEdit }
